module.exports = __webpack_public_path__ + "img/bus.45702393.jpg";